"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClosedOptions = getClosedOptions;
exports.default = exports.STATUS_FILTER_KEY = exports.SEARCH_KEY = exports.StyledThirds = void 0;

var _react = require("@lingui/react");

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _queryStringForAll = _interopRequireDefault(require("query-string-for-all"));

var _core = require("@lingui/core");

var _blocks = require("@bueno/blocks");

var _SortSelect = _interopRequireDefault(require("../SortSelect"));

var _utils = require("../../utils");

var _Exporter = require("../../../Exporter");

var _issues = require("../../../../redux/modules/_BETA/issues");

var _lists = require("../../../Action/utils/lists");

var _StatusSelect = require("../StatusSelect");

const StyledThirds = (0, _styledComponents.default)(_blocks.Thirds)`
  margin-bottom: ${_blocks.spacing.default};
`;
exports.StyledThirds = StyledThirds;
const SEARCH_KEY = 'actionsSearch';
exports.SEARCH_KEY = SEARCH_KEY;
const STATUS_FILTER_KEY = 'actionsStatus';
exports.STATUS_FILTER_KEY = STATUS_FILTER_KEY;

function getClosedOptions(i18n) {
  return [{
    value: _issues.CLOSED_ACTIONS_START_DATE.LAST_12_MONTHS,
    label: i18n._({
      id: 'actions.last_12_months',
      message: 'Last 12 months'
    })
  }, {
    value: _issues.CLOSED_ACTIONS_START_DATE.LAST_24_MONTHS,
    label: i18n._({
      id: 'actions.last_24_months',
      message: 'Last 24 months'
    })
  }, {
    value: _issues.CLOSED_ACTIONS_START_DATE.ALL_TIME,
    label: i18n._({
      id: 'actions.all_time',
      message: 'All time'
    })
  }];
}

const ActionBar = ({
  initialSearch,
  onSearchStringChange,
  data,
  filteredData,
  noResults,
  history,
  onCreateAction,
  handleClosedActionsTimeFrameChange,
  status,
  statusFilter
}) => {
  const qs = _queryStringForAll.default.parse(history.location.search);

  const currentStartDate = qs.closedOnStartDate ? Number(qs.closedOnStartDate) : _issues.CLOSED_ACTIONS_START_DATE.LAST_12_MONTHS;
  return /*#__PURE__*/React.createElement(StyledThirds, null, /*#__PURE__*/React.createElement(_blocks.Left, null, /*#__PURE__*/React.createElement(_blocks.ControlGroup, {
    tight: true
  }, /*#__PURE__*/React.createElement(_blocks.Button, {
    additive: true,
    thin: true,
    onClick: onCreateAction,
    icon: /*#__PURE__*/React.createElement(_blocks.Plus, {
      small: true
    })
  }, /*#__PURE__*/React.createElement(_react.Trans, {
    id: "actions.add_action"
  })), filteredData.length > 0 && !noResults && /*#__PURE__*/React.createElement(_Exporter.Exporter, {
    "data-cy": "export-action",
    appearance: "outline",
    rawData: filteredData,
    fileName: "Actions.csv",
    dataFormatter: _utils.getActionsExportData,
    exportType: "action"
  }, /*#__PURE__*/React.createElement(_react.Trans, {
    id: "actions.export"
  })))), /*#__PURE__*/React.createElement(_blocks.Center, null, /*#__PURE__*/React.createElement(_blocks.Search, {
    sessionKey: SEARCH_KEY,
    initial: initialSearch,
    data: data,
    onSearch: onSearchStringChange,
    defaultField: "valueString",
    indexId: "searchId",
    placeholder: _core.i18n._({
      id: 'ticket_search.v2.placeholder',
      message: `Search Actions e.g. ‘AHU’ or ‘critical’`
    }),
    cy: "ActionBar-Search"
  })), /*#__PURE__*/React.createElement(_blocks.Right, null, status === _issues.ACTION_STATUSES.open && /*#__PURE__*/React.createElement(_StatusSelect.StatusSelect, {
    value: statusFilter.selected,
    options: statusFilter.options,
    onChange: statusFilter.onChange
  }), /*#__PURE__*/React.createElement(_SortSelect.default, null), status === _issues.ACTION_STATUSES.closed && /*#__PURE__*/React.createElement(_blocks.DropdownMenu, {
    right: true,
    trigger: "History",
    value: currentStartDate,
    onSelect: option => handleClosedActionsTimeFrameChange(option),
    options: getClosedOptions(_core.i18n)
  })));
};

ActionBar.propTypes = {
  onSearchStringChange: _propTypes.default.func.isRequired,
  handleClosedActionsTimeFrameChange: _propTypes.default.func.isRequired,
  noResults: _propTypes.default.bool,
  status: _propTypes.default.string,
  statusFilter: _propTypes.default.object
};
var _default = ActionBar;
exports.default = _default;